import PageHero from "@/components/PageHero";
import FAQ, { DEFAULT_FAQ } from "@/components/FAQ";
import CTA from "@/components/CTA";

export default function Faq() {
  return (
    <>
      <PageHero
        chapter="§ FAQ"
        eyebrow="FAQ"
        title="Frequently asked."
        description="Everything you'd want to know before requesting a demo."
      />
      <FAQ items={DEFAULT_FAQ} hideHeader />
      <CTA />
    </>
  );
}
